import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import sortObject from "functions/sort-object";
import { fetchScheduleSummary } from "api/menu/dashboard/actions";

class ServicesWidget extends React.Component {
    constructor(props) {
        super(props);

        this.props.fetchScheduleSummary();
    }

    render() {
        const { scheduleSummary } = this.props;

        const scheduleSummarySorted = sortObject(
            scheduleSummary,
            Object.keys(scheduleSummary),
            "order",
            true
        );

        return (
            <div className="card">
                <div className="card-header">
                    Services
                </div>
                {!scheduleSummary.length ||
                <div className="card-body p-0">
                    <ul className="nav m-0 p-0">
                        {scheduleSummarySorted.map((index) => (
                            <li
                                key={index}
                                className="nav-item d-flex justify-content-between align-items-center border"
                            >
                                <Link
                                    to={`/schedules/maintenance/${scheduleSummary[index].mode}`}
                                    className="d-flex align-items-center nav-link"
                                    style={{
                                        fontSize: 14
                                    }}
                                >
                                    {scheduleSummary[index].category} <span
                                    className="float-right badge badge-primary ml-2">{scheduleSummary[index].numberOfServices}</span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    scheduleSummary: state.dashboard.scheduleSummary
});

const mapStateToDispatch = dispatch => ({
    fetchScheduleSummary: bindActionCreators(fetchScheduleSummary, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ServicesWidget);
